import {
  Box,
  Button, Icon, TabPanel, TabPanels,
  Text,
} from '@chakra-ui/react';
import {
  BsArrowBarUp, BsArrowCounterclockwise,
} from 'react-icons/bs';
import SidebarBox from '../Sidebar/SidebarBox';
import EditFieldSidebar from '../EditFieldSidebar';
import FormSetupRightSideBar from '../FormSetup/RigthSideBar';

const EditorSidebar = ({
  isLoading, handleDiscardDraft, handlePublish, newChanges,
}) => (
  <SidebarBox boxProps={{
    top: 0, right: 0, me: '16px', display: 'block',
  }}
  >
    <Box display="flex" gap="2">
      <Button
        leftIcon={<Icon as={BsArrowCounterclockwise} />}
        colorScheme="blue"
        variant="outline"
        size="sm"
        isDisabled={isLoading}
        onClick={handleDiscardDraft}
      >
        Discard draft
      </Button>
      <Button
        leftIcon={<Icon as={BsArrowBarUp} />}
        colorScheme="green"
        variant="solid"
        size="sm"
        onClick={handlePublish}
        isDisabled={isLoading}
      >
        Publish
      </Button>
    </Box>
    <Text fontSize="sm" color={newChanges ? 'red.500' : 'gray.500'} mt="2">
      {newChanges ? 'Changes not published' : 'Changes published'}
    </Text>
    <TabPanels borderTop="1px solid" borderColor="gray.300" mt="2">
      <TabPanel px="0">
        <FormSetupRightSideBar />
      </TabPanel>
      <TabPanel>
        <EditFieldSidebar />
      </TabPanel>
    </TabPanels>
  </SidebarBox>
);

export default EditorSidebar;
